import { slugify } from '@surfline/web-common';

export const spotGuidePath = ({ spotName, spotId }: { spotName: string; spotId: string }) =>
  `/surf-report/${slugify(spotName)}/${spotId}/spot-guide`;

export default spotGuidePath;
